module.exports = __webpack_public_path__ + "img/brakeUp.71fafba1.png";